export const modalTitleSelector = (state) => state.ui.modal.title;
export const modalContentNameSelector = (state) => state.ui.modal.contentName;
